/*common regex file for whole project */
export const REGEX = {
    REMOVE_ASTRIC: /^[\s*]+|[\s*]+$/g,
    REMOVE_SPACE: /\s+/g,
    REMOVE_ONLY_STAR: /[*\s]/g,
    DECIMAL_PATTERN: /^\d+(\.\d+)?$/,
    EMAIL_VALIDATION: /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/,
}
